import type { JSX } from "react";

import { Stack } from "@mantine/core";

import { HandshakeAnimation } from "@/common-ui/animations/handshake";

import { IVRSummary } from "../call-intro-flow/steps/customer-info/IVRSummary";
import { Header } from "../call-intro-flow/steps/Header";
import { getFormattedIntent } from "./utils/getFormattedIntent";

interface IVRHandoffProps {
    intent?: string;
    summary?: string;
    device?: string;
    productLink?: string;
}

export function IVRHandoff({ intent, summary, device, productLink }: IVRHandoffProps): JSX.Element {
    const formattedIntent = getFormattedIntent({ device, intent });
    return (
        <Stack gap={0}>
            <Stack align="center">
                <HandshakeAnimation width="40%" />
                <Header text="IVR handoff" />
            </Stack>
            {(formattedIntent || summary) && (
                <IVRSummary intent={formattedIntent} summary={summary} productLink={productLink} />
            )}
        </Stack>
    );
}
